// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__DocumentEdo from "../../../grpc/DocumentEdo.js";
import * as Buhta_cabinet__DummyTable from "../../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__Link from "../../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PageNav from "../../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__Table2 from "../../../components/molecules/Table/Table2.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (id) {
    const match = React.useState(function () {
          return 1;
        });
    const page = match[0];
    const match$1 = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match$1[0];
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const func = Buhta_cabinet__DocumentEdo.DocumentBatchService.view;
    const match$2 = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, /* [] */0, id);
          }), undefined);
    const dispatchBatch = match$2[1];
    const batch = match$2[0];
    const batchCode = typeof batch === "string" || batch.NAME !== "Data" ? "" : batch.VAL.code;
    const match$3 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__DocumentEdo.DocumentService.grid, undefined);
    const dispatch = match$3[1];
    const grid = match$3[0];
    React.useEffect((function () {
            Curry._2(dispatchBatch, undefined, undefined);
          }), []);
    React.useEffect((function () {
            const params_filters = {
              hd: {
                name: "batch_id",
                value: {
                  kind: {
                    NAME: "String_value",
                    VAL: id
                  }
                }
              },
              tl: /* [] */0
            };
            const params_expand = {
              hd: "participants",
              tl: /* [] */0
            };
            const params = {
              search: undefined,
              page: page,
              filters: params_filters,
              expand: params_expand
            };
            Curry._3(dispatch, undefined, params, undefined);
          }), [
          id,
          page
        ]);
    const docs = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */0 : grid.VAL;
    const isLoading = grid === "Loading";
    const rows = Belt__Belt_List.mapWithIndex(docs, (function (i, doc) {
            const __x = doc.participants;
            const sender = Belt__Belt_Option.getExn(Belt__Belt_List.getBy(__x, (function (p) {
                        return p["type'"] === /* DOCUMENT_PARTICIPANT_TYPE_SENDER */1;
                      })));
            const __x$1 = doc.participants;
            const recipient = Belt__Belt_Option.getExn(Belt__Belt_List.getBy(__x$1, (function (p) {
                        return p["type'"] === /* DOCUMENT_PARTICIPANT_TYPE_RECIPIENT */2;
                      })));
            const cells_0 = {
              body: doc.name,
              style: ""
            };
            const cells_1 = {
              hd: {
                body: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: Belt__Belt_Option.getWithDefault(sender.name, "")
                            }),
                        JsxRuntime.jsx("p", {
                              children: sender.sign_status === /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */2 ? "Подписан" : "Не подписан",
                              className: sender.sign_status === /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */2 ? "text-success" : "text-asphalt"
                            })
                      ]
                    }),
                style: ""
              },
              tl: {
                hd: {
                  body: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: Belt__Belt_Option.getWithDefault(recipient.name, "")
                              }),
                          JsxRuntime.jsx("p", {
                                children: recipient.sign_status === /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */2 ? "Подписан" : "Не подписан",
                                className: recipient.sign_status === /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */2 ? "text-success" : "text-asphalt"
                              })
                        ]
                      }),
                  style: ""
                },
                tl: /* [] */0
              }
            };
            const cells = {
              hd: cells_0,
              tl: cells_1
            };
            const Key = String(i);
            return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
                        cells: cells
                      }, Key);
          }));
    const currentRecords = Belt__Belt_List.length(docs);
    const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
          title: "Реестр №" + batchCode,
          rightChildren: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                route: contextRoute({
                      TAG: /* Documents */1,
                      _0: {
                        TAG: /* Batches */6,
                        _0: {
                          TAG: /* Sign */1,
                          _0: id
                        }
                      }
                    }),
                className: "bg-links hover:bg-button-primary-hover active:bg-button-primary-active rounded px-3 py-2 flex gap-1 items-center",
                children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      className: "text-white",
                      children: "Подписать все документы"
                    })
              }),
          route: contextRoute({
                TAG: /* Documents */1,
                _0: {
                  TAG: /* Batches */6,
                  _0: /* List */0
                }
              }),
          arrowBack: true
        });
    return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                header: header,
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: isLoading ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                                            header: {
                                              hd: {
                                                name: "Название",
                                                style: ""
                                              },
                                              tl: {
                                                hd: {
                                                  name: "Отправитель",
                                                  style: ""
                                                },
                                                tl: {
                                                  hd: {
                                                    name: "Получатель",
                                                    style: ""
                                                  },
                                                  tl: /* [] */0
                                                }
                                              }
                                            },
                                            rows: rows,
                                            styles: "grid-cols-[repeat(3,_auto)]"
                                          }),
                                    className: "flex-1 overflow-auto"
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                                    page: page,
                                    setPage: match[1],
                                    currentRecords: currentRecords
                                  })
                            ],
                            className: "flex h-full flex-col w-full"
                          }),
                      className: "flex flex-col w-full"
                    })
              });
  };
}

function BatchViewPage(Props) {
  return make(Props.org)(Props.id);
}

const make$1 = BatchViewPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
